import React from "react"
import { OnboardingSiteType } from "@modules/onboarding/shared/constants"
import { CmsAuthorizationModal } from "@modules/cms/authorization/components/CmsAuthorizationModal"
import { CmsIntegrationDeleteForm } from "../components/CmsIntegrationDeleteForm"

export function useCmsIntegrationControls(siteId, orgSiteName) {
  const [cmsToEdit, setCmsToEdit] = React.useState(null)
  const [cmsToRemove, setCmsToRemove] = React.useState(null)

  return {
    setCmsToEdit,
    setCmsToRemove,
    controlModals: (
      <React.Fragment>
        {cmsToEdit && (
          <CmsAuthorizationModal
            closeModal={() => setCmsToEdit(null)}
            siteId={siteId}
            formattedName={cmsToEdit.formattedName}
            isConnected={!!cmsToEdit.connected}
            orgSiteName={orgSiteName}
            name={cmsToEdit.name}
            origin={origin}
            type={OnboardingSiteType.Create}
            isOpen={Boolean(cmsToEdit)}
          />
        )}

        {cmsToRemove && (
          <CmsIntegrationDeleteForm
            siteId={siteId}
            cms={cmsToRemove}
            onDismiss={() => setCmsToRemove(null)}
          />
        )}
      </React.Fragment>
    ),
  }
}
